import { cachingService, LocalLookupService } from "@ofqual/portal-core/core/dataAccess";
import { API_HOST_REFDATA, API_HOST_SCOPE, API_HOST_USERS } from "../config";
import inclusionExclusion from "./json/inclusionExclusion.json";
import { ScopeExpansionService } from "./ScopeExpansionService";
import { PermissionTypesService } from "./PermissionTypesService";
import { QualificationTypeService } from "./QualificationTypeService";
import { LevelsService } from "./LevelsService";
import { SectorSubjectAreaService } from "./SectorSubjectAreaService";
import { TechnicalQualSubjectService } from "./TechnicalQualSubjectService";
import { ApprenticeshipStandardsService } from "./ApprenticeshipStandardsService";
import { UserService } from "./UserService";
import documentTypes from "./json/documentTypes.json";
import dateTypes from "./json/dateTypes.json";
import { StatementOfAssuranceService } from "./StatementOfAssuranceService";
import { ExpansionApplicationEvidenceRequestService } from "./ExpansionApplicationEvidenceRequestService";
import { OrgScopesService } from "./OrgScopeService";

export const scopeExpansionService = new ScopeExpansionService(API_HOST_SCOPE);
export const statementOfAssuranceService = new StatementOfAssuranceService(API_HOST_SCOPE)
export const expansionApplicationEvidenceService = new ExpansionApplicationEvidenceRequestService(API_HOST_SCOPE)
export const orgScopesService = new OrgScopesService(API_HOST_SCOPE)

export const permissionTypesService = new PermissionTypesService(API_HOST_REFDATA);
export const cachedPermissionTypesService = cachingService(
  permissionTypesService
);
export const qualificationTypeService = new QualificationTypeService(API_HOST_REFDATA);
export const cachedQualificationTypeService = cachingService(
  qualificationTypeService
);
export const levelsService = new LevelsService(API_HOST_REFDATA);
export const cachedLevelsService = cachingService(
  levelsService
);
export const sectorSubjectAreaService = new SectorSubjectAreaService(API_HOST_REFDATA);
export const cachedSectorSubjectAreaService = cachingService(
  sectorSubjectAreaService
);
export const technicalQualSubjectService = new TechnicalQualSubjectService(API_HOST_REFDATA);
export const cachedTechnicalQualSubjectService = cachingService(
  technicalQualSubjectService
);
export const apprenticeshipStandardsService = new ApprenticeshipStandardsService(API_HOST_REFDATA);
export const cachedApprenticeshipStandardService = cachingService(
  apprenticeshipStandardsService
);
export const usersService = new UserService(API_HOST_USERS);

export const inclusionExclusionService = new LocalLookupService(inclusionExclusion);
export const documentTypeService = new LocalLookupService(documentTypes);
export const dateTypeService = new LocalLookupService(dateTypes);